import lazyLoading from './lazyLoading'

export default {
  name: 'HomeNet CCTV',
  path: '/homenet/cctv',
  redirect: '/homenet/cctv/list',
  meta: {
    auth: ['user'],
    icon: 'fas fa-cube',
    expanded: false
  },
  component: lazyLoading('homenet', true),
  children: [
    {
      'name': 'List',
      'path': 'list',
      'meta': {
        'label': 'List'
      },
      'component': lazyLoading('homenet/CctvList')
    }
  ]
}



// WEBPACK FOOTER //
// ./client/store/modules/menu/cctv.js